import { PropsWithChildren } from 'react';
import { cn } from '../../lib/utils';

interface SectionTitleProps extends PropsWithChildren {
  className?: string;
}

/** Standard section heading for list/detail/dashboard views. */
export function SectionTitle({ children, className }: SectionTitleProps) {
  return (
    <h3 className={cn('text-lg font-semibold tracking-tight text-foreground', className)}>
      {children}
    </h3>
  );
}
